import React from 'react';

import './ProgressBar.css';

export default function ProgressBar({ values, max }) {
  const getPorcentValue = (value) => {
    return parseFloat(((value * 100) / max).toFixed(2));
  };

  const getTotalValues = () => {
    return values.reduce((lastValue, value) => {
      return lastValue + value.count;
    }, 0);
  };

  const getTotalValuesPercent = () => {
    const total = getTotalValues();
    return `${parseFloat(((total * 100) / max).toFixed(2))}%`;
  };

  return (
    <div>
      <div className="container-progress-bar">
        {values.map((value, key) => {
          const percent = getPorcentValue(value.count);
          if (percent > 0)
            return (
              <div
                key={`progressbar-${key}`}
                className="progress-bar-item"
                style={{
                  background: value.color,
                  width: `${percent}%`,
                }}
              />
            );
        })}
      </div>
      <div className="container-progress-bar-infos">
        <div />
        <div>{`${getTotalValues()} (${getTotalValuesPercent()})`}</div>
        <div>{max}</div>
      </div>
      <div className="container-progress-bar-labels">
        {values.map((value, key) => (
          <div key={`progressbar-label-${key}`}>
            <div className="container-progress-bar-label">
              <div
                className="progress-bar-labels-circle"
                style={{
                  background: value.color,
                }}
              />
              <div style={{ marginTop: '-2px' }}>
                <div>{value.title}</div>
                <div>{`${value.count} (${getPorcentValue(value.count)}%)`}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
